<template>
  <q-page>
    <CrossingTrackDelayTable />
  </q-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import CrossingTrackDelayTable from '@/components/tools/crossing-track-delay/CrossingTrackDelayTable.vue'

export default defineComponent({
  name: 'CrossingTrackDelay',

  components: {
    CrossingTrackDelayTable,
  },

  setup() {
    return {}
  },
})
</script>
